import { render, staticRenderFns } from "./oss-file-upload.vue?vue&type=template&id=4f466fcc&scoped=true"
import script from "./oss-file-upload.vue?vue&type=script&lang=js"
export * from "./oss-file-upload.vue?vue&type=script&lang=js"
import style0 from "./oss-file-upload.vue?vue&type=style&index=0&id=4f466fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f466fcc",
  null
  
)

export default component.exports